import axios from "axios";
import {db_url_forgot_password, url, url_auth_info, url_auth_login, url_auth_logout,} from "../url";

export const postAuthLogin = async (data) => {
    return await axios.post(url_auth_login, data)
}

export const postAuthLogout = async (data) => {
    return await axios.post(url_auth_logout, data)
}

export const getUserAuthInfo = async (token) => {
    return await axios.post(url_auth_info, token)
}

export default function DB_Auth(token) {

    const formData = new FormData()
    formData.append('token', token)

    // const appendToken = (data) => {
    //     const fd = new FormData;
    //     for (const pair of data.entries()) {
    //         fd.append(pair[0], pair[1]);
    //     }
    //     fd.append('token', token);
    //     return fd
    // }


   const sendForgotPassword = (data) => {
       return new Promise(resolve => {
           axios.post(db_url_forgot_password, data)
               .then(res => {
                   if (res.status === 200) {
                       resolve(true)
                   } else {
                       resolve(false)
                   }
               })
       })
   }

    const authentications = () => {
        const formData = new FormData()
        formData.append('token', token)

        return axios.post(url + '/auth/info', formData)
        // return axios.post('http://10.1.1.82:3001/api_web' + '/auth/info', formData)
    }


    return {
        sendForgotPassword,
        authentications
    }
}
